import ContactForm from './contact-form'
export default ContactForm
